<template>
  <div class="nav">
    <div class="nav-container">
      <router-link to="/">
        <img src="../assets/img/logo.jpg" />
      </router-link>

      <div class="nav-item-container">
        <!-- 소개 메뉴 -->
        <div class="nav-item nav1">
          소개
          <ul class="dropdown-menu">
            <li>
              <router-link :to="{ name: 'about' }">신대승네트워크</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'people' }"
                >함께하는 사람들</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'inquiry' }">문의하기</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'contact' }">오시는 길</router-link>
            </li>
          </ul>
        </div>

        <!-- 활동 메뉴 -->
        <div class="nav-item nav2">
          활동
          <ul class="dropdown-menu">
            <li v-for="board in activityBoards" :key="board.idx">
              <router-link
                :to="{ name: 'activity', params: { id: board.idx } }"
              >
                {{ board.etc }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 공지 메뉴 -->
        <div class="nav-item nav3">
          공지
          <ul class="dropdown-menu">
            <li v-for="board in newsBoards" :key="board.idx">
              <template v-if="Number(board.boardtype) === 2">
                <router-link
                  :to="{ name: 'thumbnailBoard', params: { id: board.idx } }"
                >
                  {{ board.etc }}
                </router-link>
              </template>
              <template v-else>
                <router-link
                  :to="{ name: 'notice', params: { id: board.idx } }"
                >
                  {{ board.etc }}
                </router-link>
              </template>
            </li>
          </ul>
        </div>

        <!-- 소모임 메뉴 -->
        <!-- <div class="nav-item nav4">
          소모임
          <ul class="dropdown-menu">
            <li v-for="(community, index) in communityData" :key="index">
              <router-link
                :to="{ name: 'communityboards', params: { id: community.idx } }"
              >
                {{ community.etc }}
              </router-link>
            </li>
          </ul>
        </div> -->
        <!-- <div class="nav-item nav4">
          소모임
          <ul class="dropdown-menu">
            <li v-for="(community, index) in communityData" :key="index">
              <a @click.prevent="checkLogin3(community.idx)">
                {{ community.etc }}
              </a>
            </li>
          </ul>
        </div> -->
        <div class="nav-item nav4">
          소모임
          <ul class="dropdown-menu">
            <div class="commu-dropdown">
              <li
                v-for="(communities, groupName) in groupedCommunities"
                :key="groupName"
              >
                <div class="group-header">{{ groupName }}</div>
                <ul class="sub-menu">
                  <li v-for="community in communities" :key="community.idx">
                    <a @click.prevent="checkLogin3(community.idx)">
                      {{ community.etc }}
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </ul>
        </div>

        <!-- 상담 메뉴 -->
        <div class="nav-item nav5">
          상담
          <ul class="dropdown-menu">
            <li>
              <router-link :to="{ name: 'onlineCounselingGuide' }"
                >온라인상담실 안내</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'chatRoom' }">채팅상담실</router-link>
            </li>
            <li>
              <!-- <router-link :to="{ name: 'counselingRoom' }"
                >게시판상담실</router-link
              > -->
              <a @click="checkLogin">게시판상담실</a>
            </li>
            <li>
              <!-- <router-link :to="{ name: 'memberBoard' }"
                >회원게시판</router-link
              > -->
              <a @click="checkLogin2">회원게시판</a>
            </li>
          </ul>
        </div>

        <!-- 후원 메뉴 -->
        <div class="nav-item nav6">
          후원
          <ul class="dropdown-menu">
            <li>
              <a
                href="https://view.hyosungcms.co.kr/shorten-url/jD4coQmur8"
                target="_blank"
              >
                정기후원하기
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'donationGuide' }"
                >정기후원 안내</router-link
              >
            </li>
          </ul>
        </div>

        <!-- 자료실 메뉴 -->
        <div class="nav-item nav7">
          자료실
          <ul class="dropdown-menu">
            <li v-for="board in resourcesBoards" :key="board.idx">
              <template v-if="Number(board.boardtype) === 2">
                <router-link
                  :to="{ name: 'thumbnailBoard', params: { id: board.idx } }"
                >
                  {{ board.etc }}
                </router-link>
              </template>
              <template v-else>
                <router-link
                  :to="{ name: 'notice', params: { id: board.idx } }"
                >
                  {{ board.etc }}
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import checkSession from "@/js/checkSessionAdmin.js";
import cc from "@/js/commonData.js";
import checkSession from "@/js/checkSession.js";
//import { getCurrentInstance } from "vue";

export default {
  data() {
    return {
      boards: [],
      activityBoards: [],
      newsBoards: [],
      resourcesBoards: [],
      communityData: [],
      domainUrl: cc.getDomain(),
    };
  },
  computed: {
    groupedCommunities() {
      const grouped = {};
      this.communityData.forEach((item) => {
        const group = item.groupname?.trim();
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(item);
      });
      return grouped;
    },
  },
  async mounted() {
    //const app = await getCurrentInstance();
    // //this.domainUrl = app.appContext.config.globalProperties.$domainurl;
    this.getBoardList();
    this.getCommunityList();
  },
  methods: {
    async getCommunityList() {
      try {
        const response = await axios({
          method: "post",
          url: this.domainUrl + "/community_list.php",
          withCredentials: true,
        });

        this.communityData = response["data"]["res_communityData"];
        //console.log("nav 응답 데이터:", response);
      } catch (error) {
        console.error("커뮤니티 목록을 가져오는 중 에러:", error);
      }
    },

    async getBoardList() {
      try {
        const response = await axios({
          method: "post",
          url: this.domainUrl + "/board_name_list.php",
          withCredentials: true,
        });

        this.datacount = response["data"]["res_datacnt"];
        this.boards = response["data"]["res_boardData"];
        // console.log("nav 응답 데이터:", response);
        // console.log("boardtype", response.data.res_boardData[4].boardtype);

        // 데이터 필터링하여 activityBoards에 저장
        this.activityBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "활동")
          .sort((a, b) => Number(a.idx) - Number(b.idx));

        // 데이터 필터링하여 newsBoards에 저장
        this.newsBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "공지")
          .sort((a, b) => Number(a.idx) - Number(b.idx));

        // 데이터 필터링하여 resourcesBoard 저장
        this.resourcesBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "자료실")
          .sort((a, b) => Number(a.idx) - Number(b.idx));
      } catch (error) {
        console.error("게시판 목록을 가져오는 중 에러:", error);
      }
    },

    async checkLogin() {
      const session = await checkSession.getSession();
      if (session.id === "-1") {
        alert("로그인 후 이용해주세요.");
        this.$router.push("/login");
      } else {
        this.$router.push({ name: "counselingRoom" });
      }
    },

    async checkLogin2() {
      const session = await checkSession.getSession();
      if (session.id === "-1") {
        alert("로그인 후 이용해주세요.");
        this.$router.push("/login");
      } else {
        this.$router.push({ name: "memberBoard" });
      }
    },

    async checkLogin3(idx) {
      this.$router.push({ name: "communityboards", params: { id: idx } });
      // const session = await checkSession.getSession();
      // if (session.id === "-1") {
      //   alert("로그인 후 이용해주세요.");
      //   this.$router.push("/login");
      // } else {
      //   this.$router.push({ name: "communityboards", params: { id: idx } });
      // }
    },
  },
};
</script>

<style>
@import "../assets/css/nav.css";

.commu-dropdown {
  display: flex;
  flex-direction: row;
  gap: 60px;
}

.group-header {
  font-weight: bold;
  margin-bottom: 5px;
}

.sub-menu {
  list-style: none;
  padding-left: 0;
}
</style>
